import React from 'react';
import '../assets/LoadingSpinner.css';

/**
 * LoadingSpinner Component
 * 
 * Displays an animated spinner with descriptive text during data loading.
 * Uses accessible colors and provides screen reader feedback.
 * 
 * Requirements: 4.5, 8.1
 */
const LoadingSpinner = ({ message = 'Loading...' }) => {
  // Sanitize message: use default if empty or whitespace-only
  const displayMessage = (message && message.trim()) ? message : 'Loading...';
  
  return (
    <div className="loading-spinner-container" role="status" aria-live="polite">
      <div className="spinner" aria-hidden="true"></div>
      <p className="loading-text">{displayMessage}</p>
      <span className="sr-only">Loading content, please wait</span>
    </div>
  );
};

export default LoadingSpinner;
